import * as React from 'react';
import { useAuth } from './auth';
import { PERMISSIONS } from './permissions';


export const ROLES = {
  ROOT_USER: 'superAdmin',
  COUNTRY_ADMIN: 'countryAdmin',
  COMPLIANCE_ADMIN: 'complianceAdmin',
  FINANCE_MANAGER: 'financeManager',
};

export const SUB_ROLES = {
  COUNTRY: {
    CUSTOMER_SUPPORT: 'customerSupport',
  }
}


export const useAuthorization = () => {
  const { user } = useAuth();
  if (!user) throw new Error('User does not exist!');

  const role = user.accountType;

  const permissions = PERMISSIONS[role] || [];

  const checkRoleAccess = React.useCallback(
    (allowedRoles = []) => {
      return allowedRoles.length === 0 || allowedRoles.includes(role);
    },
    [role]
  );

  const checkPermissions = React.useCallback(
    (requiredPermissions = []) => {
      return (
        requiredPermissions.length === 0 ||
        requiredPermissions.every((p) => permissions.includes(p))
      );
    },
    [permissions]
  );

  return {
    role,
    permissions,
    checkRoleAccess,
    checkPermissions,
  };
};

export const Authorization = ({
  allowedRoles = [],
  requiredPermissions = [],
  policyCheck,
  forbiddenFallback = null,
  children,
}) => {
  const { checkRoleAccess, checkPermissions } = useAuthorization();

  const hasRole = checkRoleAccess(allowedRoles);
  const hasPermission = checkPermissions(requiredPermissions);

  let canAccess = hasRole && hasPermission;

  if (typeof policyCheck === 'boolean') {
    canAccess = canAccess && policyCheck;
  }

  return <>{canAccess ? children : forbiddenFallback}</>;
};
